/*SYSTEM IMPORTS*/
    import React, { PureComponent, Fragment } from 'react'

/*INTERNAL VIEWS*/
    import { Header, Footer } from 'containers/Layout'

class MainLayout extends PureComponent {
    render() {
        const { children = null } = this.props

        return (
            <Fragment>
                <Header/>
                { children }
                <Footer />
            </Fragment>
        )
    }
}

export default MainLayout
